module.exports = "/img/about-gallery-3.99c47b2c.png";